'use client'

import classNames from 'clsx'
import { useEffect, useState } from 'react'

import ArrowUp from '@/assets/icons/back-to-top-arrow.svg'

import S from './BackToTop.module.scss'

type BackToTopProps = {
  label: string
  className?: string
}

/** Floating "page up" button: shows after one screen of scrolling. */
const BackToTop = ({ label, className }: BackToTopProps) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const update = () => setVisible(window.scrollY > window.innerHeight)
    update()
    window.addEventListener('scroll', update, { passive: true })
    return () => window.removeEventListener('scroll', update)
  }, [])

  if (!visible) {
    return null
  }

  return (
    <button
      type="button"
      className={classNames(S.button, className)}
      aria-label={label}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <ArrowUp className={S.icon} aria-hidden />
    </button>
  )
}

export default BackToTop
